const Footer = (props) => {
  return (
    <div className="footer">
      <p className="yelpDescription">Powered by</p>
      <img src="/img/YelpLogo.png" className="YelpLogo"/>
    </div>
  );
}
export default Footer;